var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Code",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 19.851,
    viewBox: "0 0 23 19.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M23.019,12.23l-4.638,4.633a.733.733,0,1,1-1.037-1.035l4.121-4.117L17.344,7.6a.733.733,0,1,1,1.037-1.035l4.638,4.633A.727.727,0,0,1,23.019,12.23ZM7.813,21.275a.76.76,0,0,1-1.044.282.771.771,0,0,1-.279-1.051L15.656,2.194A.76.76,0,0,1,16.7,1.913a.772.772,0,0,1,.279,1.051ZM6.126,16.863a.734.734,0,0,1-1.037,0L.448,12.23a.735.735,0,0,1,0-1.035l4.64-4.633A.733.733,0,1,1,6.126,7.6L2,11.711l4.121,4.117A.731.731,0,0,1,6.126,16.863Z",
    transform: "translate(-0.235 -1.809)",
    fill: "#1b6efe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/Code.d46d79eaca41ce28f6c74ad9709cd06a.svg";
export { ForwardRef as ReactComponent };